import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators'
import { pipe } from 'rxjs';

@Injectable({providedIn: 'root'})
export class CadastroProvider {

  baseUrl = environment.API_URL;
  baseAntigaUrl = environment.API_ANTIGA_URL;

  constructor(public http: HttpClient) {}

  buscarCampos(idInstituicao: any, tipo: any, idPessoa: any, idPessoaTipo: any, idPessoaAtual: any) {
    return this.http.post<any>(this.baseUrl + '/cadastro/buscar-campos',
      { tipo: tipo, idInstituicao: idInstituicao, idPessoa: idPessoa, idPessoaTipo: idPessoaTipo, idPessoaAtual: idPessoaAtual })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  salvarCadastroInicial(pessoa: any, facebook: null) {
    return this.http.post<any>(this.baseUrl + '/cadastro/salvar-cadastro',
      { pessoa: pessoa, facebook: facebook })
      .pipe(map(data => {
        return data;
      }));
  }

  salvarCadastro(pessoa: any) {
    return this.http.post<any>(this.baseUrl + '/cadastro-form/salvar-cadastro',{ 
      pessoa: pessoa 
    }).pipe(map(resposta => {
      return resposta;
    }));
  }

  addProfissao(profissao: string, idInstituicao: number) {
    return this.http
      .post<any>(`${this.baseUrl}/cadastro/add-profissao`, {
        profissao: profissao,
        idInstituicao: idInstituicao
      })
      .pipe(
        map((data) => {
          if (!data.error) {
            return data;
          }
          return false;
        })
      );
  }
}
